import BaseController from "confinus_ui/base_controller";

export default class extends BaseController {
  connect() {
    // Scroll to bottom on initial load
    this.scrollToBottom();
  }

  scrollToBottom() {
    // Use requestAnimationFrame to ensure the DOM has updated
    requestAnimationFrame(() => {
      this.element.scrollTop = this.element.scrollHeight;
    });
  }
}
